import React from 'react';
import { Check } from 'lucide-react';
export function SolutionSection() {
  return <section className="bg-white py-4 md:py-12 px-4 text-center" data-id="element-205">
      <div className="max-w-4xl mx-auto" data-id="element-206">
        <span className="inline-block bg-orange-100 text-orange-800 text-sm font-bold px-4 py-1.5 rounded-full mb-2 md:mb-4 uppercase tracking-wide" data-id="element-207">
          La Solución
        </span>

        <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 mb-2 md:mb-4" data-id="element-208">
          MEGA PACK ACERO Y MADERA
        </h2>

        <p className="text-xl text-gray-600 mb-4 md:mb-8 max-w-2xl mx-auto" data-id="element-209">
          🔨 Dominio, Habilidad & Ingresos Reales — ¿Querés aprender un oficio
          rentable, fabricar proyectos que se venden y empezar a generar
          ingresos con tus propias manos? No hace falta experiencia: podés
          comenzar hoy mismo.
        </p>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4" data-id="element-210">
          {['500+ Recursos', 'Planos Profesionales', 'Paso a Paso', 'Listo para Usar'].map(item => <div key={item} className="flex items-center gap-2 bg-orange-50 px-4 py-2 rounded-lg border border-orange-100" data-id="element-211">
              <div className="bg-[#f97316] rounded-full p-1" data-id="element-212">
                <Check className="w-4 h-4 text-white" strokeWidth={4} data-id="element-213" />
              </div>
              <span className="font-bold text-gray-800 text-lg" data-id="element-214">{item}</span>
            </div>)}
        </div>
      </div>
    </section>;
}